import { render } from "./DealExplainerPopover.vue?vue&type=template&id=0c099eae&scoped=true"
import script from "./DealExplainerPopover.vue?vue&type=script&lang=js"
export * from "./DealExplainerPopover.vue?vue&type=script&lang=js"

import "./DealExplainerPopover.vue?vue&type=style&index=0&id=0c099eae&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c099eae"]])

export default __exports__